import React, { isValidElement } from 'react';

import classNames from 'classnames';

import { useSettingsParams } from '../../../hooks/content/useSettingsParams';
import { useHeaderId } from '../../../hooks/useHeaderId';
import { InternalLink } from '../../InternalLink';
import { CustomLink } from '../CustomLink';

import * as classes from './style.module.scss';

interface Props {
  tag: string;
  anchor?: boolean;
  className?: string;
}

export const CustomHeader: React.FC<Props> = ({
  tag,
  anchor = true,
  children,
  className,
  ...props
}) => {
  const settingsParams = useSettingsParams();
  const [getSlug] = useHeaderId();
  const [slug] = getSlug(React.Children.toArray(children));

  const filteredChildren = React.Children.toArray(children).filter(
    child =>
      typeof child === 'string' ||
      (isValidElement(child) &&
        child.type !== CustomLink &&
        child.props?.mdxType !== 'a'),
  );

  return React.createElement(
    tag,
    { ...props, id: slug, className: classNames(className, classes.root) },
    <div className={classes.container}>
      {React.Children.count(children) === 1 ? children : filteredChildren}
      {anchor && (
        <InternalLink
          className={classes.hash}
          to={`${settingsParams}#${slug}`}
          title="Direct link to heading"
        >
          #
        </InternalLink>
      )}
    </div>,
  );
};
